'use client'

import { Toaster } from 'sonner'

export function ToasterProvider() {
  return (
    <Toaster
      position="top-right"
      closeButton
      duration={3500}
      gap={10}
      toastOptions={{
        classNames: {
          toast: 'toast',
          title: 'toast__title',
          description: 'toast__subtitle',
          closeButton: 'toast__close',
          icon: 'toast__icon',
        },
      }}
    />
  )
}
